import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

interface Props {
  threshold?: number;
}

export const ScrollToTopButton: React.FC<Props> = ({ threshold = 500 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed right-4 bottom-6 z-40 w-10 h-10 rounded-full flex items-center justify-center shadow-warm-md transition-colors"
          style={{
            background: "rgba(255,248,240,0.85)",
            backdropFilter: "blur(16px)",
            WebkitBackdropFilter: "blur(16px)",
            border: "1px solid rgba(255,200,150,0.15)",
          }}
          aria-label="Наверх"
        >
          <ArrowUp className="h-4 w-4 text-foreground/70" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};
